import React, { useState } from 'react';
import { Modal, Form, Input, Select, Upload,  Tag  } from 'antd';
// 使用 window.message 代替 antd 静态方法，避免 context 警告
import { InboxOutlined } from '@ant-design/icons';
import { TOPIC_OPTIONS, VISIBLE_OPTIONS } from '../../utils/constants';
import friendService from '../../services/friendService';
import uploadService from '../../services/uploadService';
import FileUploadList from '../common/FileUploadList';

const { Option } = Select;
const { Dragger } = Upload;

const CreateFriendPostModal = ({ visible, onCancel, onSuccess, defaultTopics = [], lockTopics = [], excludeTopics = [], type }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]); // 存储已上传的文件信息

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      
      // 使用已上传的文件信息构建附件列表
      const attachments = uploadedFiles.map(file => ({
        id: file.id,
        url: file.url,
        content_type: file.content_type,
      }));
      // thumb为第一个附件的完整对象（如有）
      const thumb = attachments.length > 0 ? attachments[0] : undefined;
      const payload = {
        scope: 'personal',
        prompt: values.prompt,
        response: values.response,
        topics: values.topics,
        status: values.is_public === 'all' ? 'published' : 'draft', // 全部可见为published，仅自己可见为draft
        thumb,
        attachments,
        ...(type && { type }), // 如果传入了type，则添加到payload中
      };
      await friendService.createFriendPost(payload);
      window.message?.success('帖子创建成功');
      // 重置表单和文件状态
      form.resetFields();
      setFileList([]);
      setUploadedFiles([]);
      onSuccess?.();
      onCancel();
    } catch (err) {
      if (err?.errorFields) return;
      window.message?.error(err.message || '创建失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // FileUploadList的onChange处理
  const handleFileListChange = (newList) => {
    setFileList(newList);
    // 只保留已上传（有id）的文件
    setUploadedFiles(newList.filter(f => f.id));
  };

  const handleCancel = () => {
    form.resetFields();
    setFileList([]);
    setUploadedFiles([]);
    onCancel();
  };

  return (
    <Modal
      title="创建帖子"
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="确认创建"
      cancelText="取消"
      confirmLoading={loading}
      width={520}
      destroyOnClose
      maskClosable={false}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="多媒体">
          <FileUploadList fileList={fileList} onChange={handleFileListChange} maxCount={1} accept="image/*" />
        </Form.Item>
        <Form.Item label="标题" name="prompt" rules={[{ required: true, message: '请输入标题' }]}> 
          <Input placeholder="分享你参与的项目或是个人经历..." />
        </Form.Item>
        <Form.Item label="正文" name="response" rules={[{ required: true, message: '请输入正文' }]}> 
          <Input.TextArea
            rows={4}
            placeholder={`📅社团经历/项目/实习起止时间\n🔍讲述你聚焦的项目，担任的岗位/角色...\n ✨主导 / 参与 的工作，推动项目输出的阶段性成果\n支持markdown格式`}
          />
        </Form.Item>
        <Form.Item label="话题" name="topics"> 
          <Select
            mode="multiple"
            maxTagCount={5}
            maxTagTextLength={8}
            placeholder="请选择"
            showArrow
            allowClear
            maxTagPlaceholder={omittedValues => `+${omittedValues.length}`}
            onChange={values => {
              // 不能删除 lockTopics
              let next = values;
              if (lockTopics && lockTopics.length > 0) {
                // 自动补回 lockTopics
                next = Array.from(new Set([...next, ...lockTopics]));
              }
              if (next.length > 5) {
                next = next.slice(0, 5);
                window.message?.warning('最多选择5个话题');
              }
              form.setFieldsValue({ topics: next });
            }}
            tagRender={props => {
              const locked = lockTopics && lockTopics.includes(props.value);
              return (
                <Tag color={locked ? 'red' : 'blue'} closable={!locked && props.closable} onClose={props.onClose} style={{ marginRight: 3 }}>
                  {props.value}
                </Tag>
              );
            }}
          >
            {TOPIC_OPTIONS.filter(opt => !(excludeTopics && excludeTopics.includes(opt.value))).map(opt => (
              <Option key={opt.value} value={opt.value} disabled={lockTopics && lockTopics.includes(opt.value)}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="可见范围" name="is_public" rules={[{ required: true, message: '请选择可见范围' }]}> 
          <Select placeholder="请选择可见范围">
            {VISIBLE_OPTIONS.map(opt => <Option key={opt.value} value={opt.value}>{opt.label}</Option>)}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateFriendPostModal;
